export default {
	'Are you sure you want to restore all configurations to the default values?': '確定要恢復全部配置到默認值嗎？',
	'Background color when hovering over the top bar': '頂欄懸停時背景色',
	'Background page switching animation': '後臺頁面切換動畫',
	classic: '經典',
	'Dark mode': '暗黑模式',
	default: '默認',
	'Double column': '雙欄',
	'Exit full screen': '退出全屏',
	'Full screen is not supported': '您的瀏覽器不支持全屏，請更換瀏覽器再試~',
	'Layout configuration': '布局配置',
	'Layout mode': '布局方式',
	Login: '登錄',
	'Login to the buildadmin': '登錄到 BuildAdmin 開源社區',
	Logout: '註銷',
	'Member center': '會員中心',
	'Member information': '會員信息',
	'overall situation': '全局',
	Password: '密碼',
	'Please enter buildadmin account name or email': '請輸入 BuildAdmin 帳戶名/電子郵箱/手機號',
	'Please enter the buildadmin account password': '請輸入 BuildAdmin 帳戶密碼',
	'Please select an animation name': '請選擇動畫名稱',
	Profile: '個人資料',
	Register: '沒有帳戶？去註冊',
	'Restore default': '恢復默認',
	'Show side menu top bar (logo bar)': '顯示側邊菜單頂欄(LOGO欄)',
	'Side menu accordion': '側邊菜單手風琴',
	'Side menu active item background color': '側邊菜單激活項背景色',
	'Side menu active item text color': '側邊菜單激活項文字色',
	'Side menu bar background color': '側邊菜單欄背景色',
	'Side menu default icon': '側邊菜單默認圖標',
	'Side menu horizontal collapse': '側邊菜單水平摺疊',
	'Side menu text color': '側邊菜單文字顏色',
	'Side menu top bar background color': '側邊菜單頂欄背景色',
	'Side menu width (when expanded)': '側邊菜單寬度(展開時)',
	sidebar: '側邊欄',
	'Single column': '單欄',
	'Top bar': '頂欄',
	'Top bar background color': '頂欄背景色',
	'Top bar menu active item background color': '頂欄菜單激活項背景色',
	'Top bar menu active item text color': '頂欄菜單激活項文字色',
	'Top bar text color': '頂欄文字色',
	Username: '用戶名',
}
